import { Button, useMantineTheme } from "@mantine/core";
import { IconCrown } from "@tabler/icons-react";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import { PlanType } from "../../common/users/user.schema";

const PlanPrompt = ({ plan }: { plan: PlanType }) => {
  const theme = useMantineTheme();
  const { t } = useTranslation();
  return (
    <Button
      href="/pricing"
      component={Link}
      variant="outline"
      size="xs"
      leftSection={<IconCrown color={theme.colors.yellow[2]} />}
    >
      {plan === PlanType.CLUB && t("Club plan")}
      {plan === PlanType.TEAM && t("Team plan")}
    </Button>
  );
};
export default PlanPrompt;
